import ExternalStoreHandler from './ExternalStoreHandler';
import * as _ from 'lodash';
import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';
import {communicationService} from "../../../services/communicationService";
import {commandKeys} from "../../../shared/commandKeys";
import {utils} from "../../../utils/shopifyInjector/utils";

const cartonomyLogo = require('../../../resources/images/cartonomy-icon.svg');

ApplicationController.$inject = [ '$scope', '$rootScope', '$timeout',
    'cartonomyConfig', '$state',
    'AuthenticationService', 'Session',
    'ConfigurationService', 'CartService', 'UserProfile',
    'OrderSetupService', 'Message', 'GroupOrder',
    'RealTimeUpdateService',
    'HeapService',
    'LocalForageService', '$translate' ];

export default function ApplicationController($scope, rootScope, timeout,
                                              cartonomyConfig, $state,
                                              authenticationService, sessionService,
                                              configurationService, cartService,
                                              userProfileService, orderSetupService,
                                              messageService,
                                              groupOrderService,
                                              RealTimeUpdateService,
                                              HeapService,
                                              localForageService,
                                              $translate) {
    rootScope.cartonomyLogoSvg = cartonomyLogo;

    // Load retailer styles
    const defaultStylesLink = document.createElement("link");
    defaultStylesLink.type = "text/css";
    defaultStylesLink.rel = "stylesheet";
    defaultStylesLink.href = `${cartonomyConfig.backendEndPoint}/api/styles/defaultStyle${window.location.search}`;
    document.head.appendChild(defaultStylesLink);

    const retailerStylesLink = document.createElement("link");
    retailerStylesLink.type = "text/css";
    retailerStylesLink.rel = "stylesheet";
    retailerStylesLink.href = `${cartonomyConfig.backendEndPoint}/api/styles/shopify${window.location.search}`;
    document.head.appendChild(retailerStylesLink);

    // check if window is inside frame
    let isInIframe = window.self !== window.top;

    if (!isInIframe) {
        $scope.noError = true;
        if (!cartonomyConfig.externalStoreMode) {
            messageService.showErrorPopup('There has been an application error. Please return to your Shopify store.');
            return;
        }
        let url = `${window.location.protocol}//${cartonomyConfig.externalStoreUrl}/${window.location.hash}`;
        window.location.href = url;
        return;
    }

    $scope.siteName = '';
    $scope.logoImage = '';
    $scope.retailer = null;
    let _lastCartResult = null;
    let oldCart;


    $scope.isExternalRetailer = () => isExternalRetailer();

    rootScope.isExternalRetailer = () => isExternalRetailer();

    localForageService.retrieve(Constants.SessionStorage.SAFARI_WARNING_SHOWED)
    .then(safariWarning => {
        rootScope.safariWarningShowed = safariWarning  || false;
    });

    rootScope.isMobile = () => (/ios|iphone|android/gi).test(navigator.userAgent);
    rootScope.isSafari = () => (/^((?!chrome|android).)*safari/i).test(navigator.userAgent);

    rootScope.displaySafariWarning = async () => {
        rootScope.safariWarningIsShowing = true;
        await messageService.showMessagePopup($translate.instant('client.safari_warning'));
        rootScope.safariWarningIsShowing = false;
        rootScope.safariWarningShowed = true;
        await localForageService.store(Constants.SessionStorage.SAFARI_WARNING_SHOWED, true);
    };

    $scope.isCartOwner = async() => await cartService.isCartOwner();
    sessionService.loggedIn().then((loggedIn) => {
        rootScope.isLoggedin = loggedIn;
    });

    $scope.currentState = () => $state.current.name.replace(/\./g, '-');

    $scope.onCartBagClicked = () => {
        if (isExternalRetailer()) {
            if ($scope.isCart()) {
                rootScope.$broadcast(Constants.BroadcastMessages.CART_PAGE_REQUESTED);
            } else {
                $scope.showPopupBag();
                $state.go(Constants.RoutingStates.CART);
            }
        } else {
            $scope.showPopupBag();
        }
    };

    $scope.showPopupBag = function () {
        $scope.$broadcast(Constants.BroadcastMessages.TOGGLE_POPUP_BAG);
    };

    $scope.showCatalog = function () {
        $scope.$broadcast(Constants.BroadcastMessages.HIDE_POPUP_BAG);
        $state.go(Constants.RoutingStates.CATALOG);
    };

    $scope.showSplashScreen = function () {
        $scope.$broadcast(Constants.BroadcastMessages.HIDE_POPUP_BAG);
        $scope.$broadcast(Constants.Events.OPEN_SPLASH_SCREEN);
    };

    $scope.showChat = function () {
        $scope.$broadcast(Constants.BroadcastMessages.HIDE_POPUP_BAG);
        $state.go(Constants.RoutingStates.CHAT);
    };

    $scope.showVersionPage = function () {
        $scope.$broadcast(Constants.BroadcastMessages.HIDE_POPUP_BAG);
        $state.go(Constants.RoutingStates.ABOUT);
    };

    $scope.showAccount = async () => {
        $scope.$broadcast(Constants.BroadcastMessages.HIDE_POPUP_BAG);

        if (await sessionService.isInvite()) {
            authenticationService.showSignupDialog(await sessionService.getUserEmail());
            return;
        }

        if (!(await sessionService.loggedIn()) || await sessionService.isInvite()) {
            await authenticationService.showLoginDialog();
            return;
        }

        await authenticationService.ensureLoggedIn();
        $state.go(Constants.RoutingStates.USER_PROFILE);
    };

    $scope.showInvitedPeople = async () => {
        $scope.$broadcast(Constants.BroadcastMessages.HIDE_POPUP_BAG);

        if (await sessionService.isInvite()) {
            authenticationService.showSignupDialog(await sessionService.getUserEmail());
            return;
        }

        if (!(await sessionService.loggedIn()) || await sessionService.isInvite()) {
            await authenticationService.showLoginDialog();
            return;
        }

        await authenticationService.ensureLoggedIn();
        $state.go(Constants.RoutingStates.INVITED_PEOPLE);
    };

    $scope.isCatalog = function () {
        return $state.is(Constants.RoutingStates.CATALOG);
    };

    $scope.isCart = function () {
        return $state.is(Constants.RoutingStates.CART) || !($scope.groupOrderCreated || $scope.isProfile());
    };

    $scope.isInvitePeople = function() {
        return $state.is(Constants.RoutingStates.INVITED_PEOPLE);
    };

    $scope.isProfile = function () {
        return $state.is(Constants.RoutingStates.USER_PROFILE);
    };

    $scope.isChat = function () {
        return $state.is(Constants.RoutingStates.CHAT);
    };

    $scope.isCheckout = function () {
        return $state.is(Constants.RoutingStates.CHECKOUT);
    };

    $scope.isShowTabButton = function () {
        return $scope.groupOrderCreated && !$scope.isCheckout() && !$scope.isDialogOpened && !$scope.isOrderFreezed;
    };

    $scope.isCatalogVisible = function () {
        return !isExternalRetailer() && !$scope.isCheckout();
    };

    $scope.isInvitedPeopleAvailable = function () {
        return $scope.groupOrderCreated && !$scope.isCheckout();
    };

    $scope.isProfileVisible = function () {
        return rootScope.isLoggedin && !$scope.isCheckout() && !$scope.isShowBackButton;
    };

    $scope.isCartVisible = function () {
        return rootScope.isLoggedin && !($scope.isDialogOpened && $scope.groupOrderCreated);
    };

    $scope.isChatVisible = function () {
        return $scope.groupOrderCreated && !$scope.isCheckout();
    };

    $scope.isCreateOrderVisible = function () {
        return !$scope.groupOrderCreated && !$scope.isCheckout();
    };

    $scope.isEditOrderVisible = function () {
        return $scope.groupOrderCreated && $scope.groupOrderOwner && !$scope.isCheckout();
    };

    $scope.createGroupOrder = async () => {
        let result = await orderSetupService.createOrder();
        if (!result || !result.stateToGo)
            $state.go(cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CHAT : Constants.RoutingStates.CATALOG);
        else
            $state.go(result.stateToGo);
    };

    $scope.editGroupOrder = function () {
        orderSetupService.editOrder(Constants.OrderSetupTabs.DELIVERY_ADDRESS);
    };

    $scope.back = function () {
        rootScope.$broadcast(Constants.Events.BACK_BUTTON_CLICKED);
    };
    
    $scope.hideMessage = function () {
        if(rootScope.headerMessage) {
            rootScope.headerMessage.resolve(true);
            rootScope.headerMessage = null;
        }
    };
    //CW-2252: improve load experience
    $scope.loading = null;

    $scope.isShowBackButton = false;
    $scope.isDialogOpened = false;
    async function updateProperties(getUserFromCache = true) {
        $scope.isGuest = !(await sessionService.loggedIn());
        function setDefaultProfile() {

            $scope.profile = {
                name: '',
                welcome: 'Login',
                email: '',
                emails: '',
                addresses: '',
                avatar: ''
            };
        }

        if (!(await sessionService.loggedIn())) {
            setDefaultProfile();
            return;
        }

        try {
            const user = await userProfileService.getUser(getUserFromCache);
            $scope.profile = {
                name: user.fullName,
                firstName: user.firstName,
                lastName: user.lastName,
                welcome: $translate.instant('client.user.welcome', {  firstName: user.firstName}),
                isInvite: await sessionService.isInvite(),
                email: user.email,
                emails: _.sortBy(user.userEmails, [ 'main', 'email' ]),
                addresses: user.addresses,
                avatar: user.avatarSrc || Constants.DEFAULT_AVATAR_URL,
                avatarCropped: user.avatarCropped,
                linkOAuthOnly: user.linkOAuthOnly,
                linkedOAuth: user.linkedOAuth
            };
            if ($scope.profile.isInvite) {
                $scope.profile.welcome += `. ${$translate.instant('client.user.signup_here')}.`;
            }

            if (!$scope.$root.$$phase) {
                $scope.$apply();
            }
        } catch (error) {
            setDefaultProfile();
        }
    }

    async function setOrderProperties() {
        const properties = await cartService.getCartProperties();
        $scope.groupOrderCreated = properties.isGroupOrder;
        $scope.groupOrderTitle = properties.title;
        $scope.singlePayGroupOrder = properties.singlePay;
        $scope.groupOrderOwner = properties.isOwner;
        scopeUtils.apply($scope);
    }

    async function setCartProperties(getUserFromCache = true) {
        updateProperties(getUserFromCache);
        setOrderProperties();

        if (!oldCart) {
            oldCart = await cartService.getCart();
            return;
        }

        const cart = await cartService.getCart();

        const lastLeftCart = cartService.getLastLeftCart();

        const lastCartStatusResult = await cartService.getUserLastCart();

        if (_.isEqual(_lastCartResult, lastCartStatusResult)) {
            return;
        }

        if (lastCartStatusResult.status === 'CANCELLED' || lastCartStatusResult.status === 'ORDER_PLACED' && isExternalRetailer()) {
            return;
        }

        if (lastCartStatusResult && lastCartStatusResult.message) {
            _lastCartResult = lastCartStatusResult;
            await messageService.showMessagePopup(lastCartStatusResult.message);
        }

        oldCart = cart;
    }

    async function userLoggedOut() {
        $scope.hideMessage();
        setCartProperties(false);
        rootScope.isLoggedin = false;
    }

    function isExternalRetailer() {
        return cartonomyConfig.externalStoreMode;
    }

    function dialogOpened($event, showBackButton) {
        $scope.isShowBackButton = showBackButton;
        $scope.isDialogOpened = true;
    }

    function dialogClosed(){
        $scope.isShowBackButton = false;
        $scope.isDialogOpened = false;
        rootScope.storeWindowTitle = $state.current.windowTitle || '';
    }

    rootScope.$on(Constants.RootEvents.CART_CHANGED, () => setCartProperties());
    rootScope.$on(Constants.RootEvents.USER_PROFILE_UPDATED, () => setCartProperties(false));
    rootScope.$on(Constants.Events.USER_LOGGED_OUT, () => userLoggedOut());

    rootScope.$on(Constants.Events.ORDER_CANCELLED, () => cancelRealtimeUpdate());
    rootScope.$on(Constants.Events.ORDER_CANCELLED_BY_OWNER, () => cancelRealtimeUpdate());
    rootScope.$on(Constants.Events.ORDER_CHECKED_OUT, () => cancelRealtimeUpdate());
    rootScope.$on(Constants.Events.LEFT_ORDER, () => cancelRealtimeUpdate());

    rootScope.$on(Constants.Events.ORDER_CREATED, () => connectRealtimeUpdate());
    rootScope.$on(Constants.Events.INVITATION_ACCEPTED, () => connectRealtimeUpdate());
    rootScope.$on(Constants.Events.DIALOG_OPENED, ($event, showBackButton) => dialogOpened($event, showBackButton));
    rootScope.$on(Constants.Events.DIALOG_CLOSED, () => dialogClosed());
    rootScope.$on('$stateChangeStart',
        function (event, toState) {
            rootScope.storeWindowTitle = toState.windowTitle || '';
        });


    async function connectRealtimeUpdate() {
        $scope.hideMessage();
        RealTimeUpdateService.ensureConnected();
    }

    async function checkAndConnectRealtimeUpdateIfNeeded() {
        await checkAndShowSafariWarning();

        let isGroupOrder = await cartService.isGroupOrder();
        if (isGroupOrder) {
            RealTimeUpdateService.ensureConnected();
        }
        rootScope.isLoggedin = true;
    }

    async function checkAndShowSafariWarning() {
        const user = await userProfileService.getUser();

        rootScope.isStoreAdmin = user.userType === Constants.UserTypes.StoreAdmin || user.isUserAdmin;

        if (!rootScope.isSafari() || rootScope.safariWarningShowed)
            return;

        if (user.showMacSafariMessage) {
            rootScope.displaySafariWarning();
        }
    }

    function cancelRealtimeUpdate() {
        $scope.hideMessage();
        RealTimeUpdateService.disconnect(true);
        RealTimeUpdateService.reset();
    }

    this.$onInit = async () => {
        //CW-2252: improve load experience
        $scope.loading = await messageService.showLoadingWhiteBackground();

        HeapService.identify(sessionService.getAuthToken());

        let retailer = await configurationService.getItem('retailer');

        if (retailer.status !== 'Available') {
            HeapService.track('CartonomyNotAvailable', {retailer: retailer});
            window.parent.postMessage({
                disableCartonomy: true
            }, '*');
            return;
        }
        $scope.siteName = retailer.name;
        $scope.logoImage = retailer.retailerImg;
        $scope.retailer = retailer;
        rootScope.retailer = retailer;

        if (cartonomyConfig.externalStoreMode) {
            $scope.externalStoreHandler = new ExternalStoreHandler(
                $scope, rootScope, timeout,
                authenticationService,
                sessionService, cartService,
                groupOrderService, orderSetupService, $state, messageService, localForageService, HeapService, $translate);

            await $scope.externalStoreHandler.initialize();
        }

        await updateProperties(true);
        await setCartProperties();

        let isGroupOrder = await cartService.isGroupOrder();
        if (await sessionService.loggedIn()) {
            await checkAndShowSafariWarning();

            if (isGroupOrder) {
                await connectRealtimeUpdate();
            }
        }

        rootScope.$on(Constants.Events.USER_LOGGED_IN, (scope) => checkAndConnectRealtimeUpdateIfNeeded());
        if($scope.loading){
            //CW-2252: improve load experience
            $scope.loading.close();
            $scope.loading = null;
        }

        const result = await communicationService.requestToParent(commandKeys.moneyFormatChange);
        rootScope.moneyFormat = result.moneyFormat;
        utils.moneyFormat = result.moneyFormat;
        rootScope.formatAmount = (amount) => {
            if (!amount) {
                return '';
            }
            return rootScope.moneyFormat.replace('{{amount}}', amount.toFixed(2));
        }
    };
}



// WEBPACK FOOTER //
// ./src/modules/shared/controllers/ApplicationController.js